import { render, staticRenderFns } from "./PublicCpRegistrationForm.vue?vue&type=template&id=55bc9d0a&scoped=true"
import script from "./PublicCpRegistrationForm.vue?vue&type=script&lang=js"
export * from "./PublicCpRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./PublicCpRegistrationForm.vue?vue&type=style&index=0&id=55bc9d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc9d0a",
  null
  
)

export default component.exports